export const ADD_CONTACT = "v2/contacts";
export const GET_CONTACTS = "v2/contacts";
export const GET_CONTACT = "v2/contacts/by-email";